
/* injects from baggage-loader */
require('./style.scss');

import React, { useState } from "react";
import Config from "../../../config/main";
import { useDataFetch } from "../customHooks/dataFetch";
import CMSApi from "../../../services/cmsApi";
import CasinoGamesList from "./components/gamesList";
import Loader from "../../components/loader";
import CasinoTopBar from "./components/topBar";

const initialPaging = {
	offset: 0,
	limit: Config.casino.games.loaderStep,
};

const Casino = () => {
	const [filter, setFilter] = useState({
		provider: Config.casino.defaultFilteredProvider?.join(",") || null,
		search: null,
		...initialPaging,
	});

	const [data, loading] = useDataFetch(() => CMSApi.getCasinoGames(filter), [filter]);

	const prevPage = () => {
		const { offset, limit } = filter;

		offset &&
			setFilter({
				...filter,
				offset: offset - Config.casino.games.loaderStep,
				limit: limit - Config.casino.games.loaderStep,
			});
	};

	const nextPage = () => {
		const { offset, limit } = filter;

		limit < +data?.total_count &&
			setFilter({
				...filter,
				offset: offset + Config.casino.games.loaderStep,
				limit: limit + Config.casino.games.loaderStep,
			});
	};

	return (
		<>
			{data && (
				<div className="casino-wrapper">
					<div className="casino-games-list-view">
						<div className="single-game-type-list">
							<CasinoTopBar
								filter={filter}
								onChange={changedFilter =>
									setFilter({
										...changedFilter,
										...initialPaging,
									})
								}
							/>

							<CasinoGamesList games={data?.games} />
						</div>
						<div className="slider-arrow-t">
							<div className="left-arrow-t" onClick={prevPage}>
								<i className="icon-s-t" />
							</div>
							<div className="right-arrow-t" onClick={nextPage}>
								<i className="icon-s-t" />
							</div>
						</div>
					</div>
				</div>
			)}

			{loading && <Loader component="containers-casino" />}
		</>
	);
};

export default Casino;
